import type { RoomViewVMNoActiveGameTileVM } from './playAreaVM.types'

export type ArrangeGameTilesInput = {
  /** Every tile this viewer may browse, in catalog order. */
  all: RoomViewVMNoActiveGameTileVM[]
  /** Tiles for the curated games, in the owner's order. */
  curated: RoomViewVMNoActiveGameTileVM[]
  isCurated: boolean
  canEdit: boolean
  showAll: boolean
}

/**
 * Orders the game list for a curated room (see
 * wiki/decisions/2026-10-10-let-owners-curate-a-rooms-games.md): participants
 * see only the curated games; the owner sees them first, annotated for
 * editing, followed by the rest of the catalog when Show all games is on.
 * An uncurated room keeps the catalog as is.
 */
export function arrangeGameTiles({ all, curated, isCurated, canEdit, showAll }: ArrangeGameTilesInput): RoomViewVMNoActiveGameTileVM[] {
  if (!isCurated) return all
  if (!canEdit) return curated

  const editable = curated.map((tile) => ({ ...tile, curation: { placement: 'curated' as const } }))
  if (!showAll) return editable

  const curatedIds = new Set(curated.map((tile) => tile.gameId))
  const others = all
    .filter((tile) => !curatedIds.has(tile.gameId))
    // The New Game wizard is not a catalog game and cannot be curated.
    .map((tile) => (tile.gameId === 'new-game' ? tile : { ...tile, curation: { placement: 'available' as const } }))
  return [...editable, ...others]
}
